<template>
  <div>
    <span
      style="white-space: nowrap"
      :class="{
        task: task.task_type.id === 1,
        meeting: task.task_type.id === 2,
        announcement: task.task_sub_type
          ? task.task_sub_type.id === 4
          : taskIsAnnouncement(),
        openshift: task.task_sub_type
          ? task.task_sub_type.id === 5
          : taskIsOpenShift(),
        'email-task': task.task_type.id === 4,
        repeated: task.task_type.id === 5,
        outline: task.task_sub_type
          ? task.task_sub_type.id === 3
          : taskIsOutline(),
        'task-question': task.task_sub_type
          ? task.task_sub_type.id === 6
          : taskIsQuestion()
        // || taskIsOutline()
      }"
      >{{ getTitleForTaskTypeFromSubType() }}</span
    >
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "TaskType",
  props: {
    task: {
      type: Object,
      required: true
    },
    selectedTab: {
      type: String
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  methods: {
    taskIsAnnouncement() {
      return this.task.taskSubStatus.some(
        sub => sub.sub_status_id === 31 && sub.user_id === this.auth.user.id
      );
    },
    taskIsOutline() {
      // return this.task.start_time === this.task.end_time
      return this.task.taskSubStatus.some(
        sub => sub.sub_status_id === 50 && sub.user_id === this.auth.user.id
      );
    },
    taskIsOpenShift() {
      return this.task.taskSubStatus.some(
        sub => sub.sub_status_id === 46 && sub.user_id === this.auth.user.id
      );
    },
    taskIsQuestion() {
      return this.task.taskSubStatus.some(
        // sub => sub.sub_status_id === 51 && sub.user_id === this.auth.user.id
        sub => sub.sub_status_id === 51
      );
    },
    getTitleForTaskType() {
      if (this.selectedTab === "outline" || this.taskIsOutline()) {
        return "Outline";
      } else if (this.taskIsAnnouncement()) {
        return "Announcement";
      } else if (this.taskIsOpenShift()) {
        return "Open Shift";
      } else if (this.taskIsQuestion()) {
        return "Question";
      }
      // else if (this.taskIsOutline()) {
      //   return "Outline";
      // }
      else {
        return this.task.task_type.title;
      }
    },
    getTitleForTaskTypeFromSubType() {
      return this.task.task_sub_type
        ? this.task.task_sub_type.title
        : this.getTitleForTaskType();
    }
  },
  mounted() {}
};
</script>

<style scoped>
.meeting {
  background-color: #7b1fa2;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}
.comp-meeting {
  background-color: #880e4f;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}
.email-task {
  background-color: #1b5e20;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}
.task {
  background-color: #2c4762;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}
.repeated {
  background-color: #827717;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}
.outline {
  background-color: white;
  color: black;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}

.announcement {
  background-color: #b9c554;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}
.openshift {
  background-color: #1565c0;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}
.task-question {
  background-color: #2c7c18;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
}

.hasWaitingConfirmationDot {
  height: 10px;
  width: 10px;
  background-color: #ff8c68;
  border-radius: 50%;
  display: inline-block;
  margin-left: 0.3rem;
}
</style>
